import { isStudioUrlLocaleSegment } from 'cf-i18n/helpers'

/** Whether the first URL path segment is a supported Studio locale path prefix. */
export function isRouteLocale(segment: string | undefined): boolean {
  return segment !== undefined && isStudioUrlLocaleSegment(segment)
}
